import { render, staticRenderFns } from "./EmailVerificationSignupStep.vue?vue&type=template&id=2bd0c7bb&"
import script from "./EmailVerificationSignupStep.vue?vue&type=script&lang=ts&"
export * from "./EmailVerificationSignupStep.vue?vue&type=script&lang=ts&"
import style0 from "./EmailVerificationSignupStep.vue?vue&type=style&index=0&id=2bd0c7bb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports